import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useSearchParams } from 'react-router-dom'
import PageWrapper from "Pages/@PageWrapper"
import { Box, Grid } from "@mui/material"
import { LEADING_PRICE_ROUTES } from "@constants/routes"
import LeadingAnalyzerFilters from "Pages/BusinessLogistics/LeadingAnalyzer/Page/Filters"
import { resetLeadingFilters, setFormData, tableData } from "Pages/BusinessLogistics/LeadingAnalyzer/Page/@signals"
import { isLoadingCommonFilters } from "@signals"
import { AppStartHint, searchStartHintProps } from "@components"
import LeadingAnalyzerTable from "Pages/BusinessLogistics/LeadingAnalyzer/Page/Table"
import LeadingAnalyzerActions from "Pages/BusinessLogistics/LeadingAnalyzer/Page/Actions"
import LeadingUrlModal from "Pages/BusinessLogistics/LeadingAnalyzer/Page/UrlModal"
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from "./VirtualTour"
import LeadingDemoData from "./VirtualTour/DemoData"

export default function LeadingAnalyzerPage() {
	const [tourActive, setTourActive] = useState(false)
	const [searchParams] = useSearchParams()

	useEffect(() => {
		resetLeadingFilters()

		const sp = searchParams.get('sp')
		if (sp) {
			try {
				const bytes = new Uint8Array([...atob(sp)].map(c => c.charCodeAt(0)))
				const decoded = JSON.parse(new TextDecoder().decode(bytes))
				setFormData(decoded)
			} catch {}
		}

		return () => {
			resetLeadingFilters()
		}
	}, [])

	return <PageWrapper
		head={`DS Rentacar | ${LEADING_PRICE_ROUTES.SUBTITLE}`}
		title={LEADING_PRICE_ROUTES.TITLE}
		subtitle={LEADING_PRICE_ROUTES.SUBTITLE}
		filters={<LeadingAnalyzerFilters/>}
		actions={<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
			<LeadingAnalyzerActions/>
			<VirtualTourButton onClick={() => setTourActive(true)}/>
		</Box>}
	>
		<LeadingUrlModal/>
		{tableData.value.empty && !tableData.value.noResults && !isLoadingCommonFilters.value && !tourActive && <AppStartHint {...searchStartHintProps}/>}
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<LeadingAnalyzerTable/>
			</Grid>
		</Grid>
		{tourActive && <LeadingDemoData/>}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => setTourActive(false)}/>,
			document.body
		)}
	</PageWrapper>
}